import React, { useState } from 'react';
import { Header } from './components/Header';
import { HeroSearch } from './components/HeroSearch';
import { QuickActions } from './components/QuickActions';
import { SLAInfo } from './components/SLAInfo';
import { KnowledgeBase } from './components/KnowledgeBase';
import { TicketForm } from './components/TicketForm';
import { MyTickets } from './components/MyTickets';
import { knowledgeBaseArticles } from './data/mockData';
import { BookIcon, ChevronRightIcon } from 'lucide-react';
export function App() {
  const [activeView, setActiveView] = useState('home');
  const [searchQuery, setSearchQuery] = useState('');
  const handleNavigate = (view: string) => {
    setActiveView(view);
    window.scrollTo(0, 0);
  };
  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };
  // Featured articles for home page
  const featuredArticles = knowledgeBaseArticles.slice(0, 3);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-0">
      <Header activeView={activeView} onNavigate={handleNavigate} data-id="element-1" />

      <main data-id="element-2">
        {activeView === 'home' && <div className="animate-in fade-in duration-300" data-id="element-3">
            <HeroSearch onSearch={handleSearch} onNavigate={handleNavigate} data-id="element-4" />
            <QuickActions onNavigate={handleNavigate} data-id="element-5" />

            {/* Featured KB Articles Preview */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-t border-slate-200" data-id="element-6">
              <div className="flex items-center justify-between mb-8" data-id="element-7">
                <h2 className="text-2xl font-bold text-slate-900 flex items-center" data-id="element-8">
                  <BookIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-9" />
                  Popular Help Articles
                </h2>
                <button onClick={() => handleNavigate('knowledge-base')} className="text-blue-600 hover:text-blue-700 font-medium flex items-center text-sm" data-id="element-10">
                  View all <ChevronRightIcon className="w-4 h-4 ml-1" data-id="element-11" />
                </button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-12">
                {featuredArticles.map(article => <div key={article.id} onClick={() => handleNavigate('knowledge-base')} className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-blue-300 cursor-pointer transition-all group" data-id="element-13">
                    <span className="text-xs font-medium text-slate-500 mb-2 block" data-id="element-14">
                      {article.category}
                    </span>
                    <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2" data-id="element-15">
                      {article.title}
                    </h3>
                    <p className="text-sm text-slate-600 line-clamp-2" data-id="element-16">
                      {article.summary}
                    </p>
                  </div>)}
              </div>
            </div>

            <SLAInfo data-id="element-17" />
          </div>}

        {activeView === 'knowledge-base' && <div className="animate-in fade-in duration-300" data-id="element-18">
            <KnowledgeBase initialSearchQuery={searchQuery} data-id="element-19" />
          </div>}

        {activeView === 'submit-ticket' && <div className="animate-in fade-in duration-300" data-id="element-20">
            <TicketForm data-id="element-21" />
          </div>}

        {activeView === 'my-tickets' && <div className="animate-in fade-in duration-300" data-id="element-22">
            <MyTickets onNavigate={handleNavigate} data-id="element-23" />
          </div>}
      </main>

      {/* Simple Footer */}
      <footer className="bg-white border-t border-slate-200 py-8 mt-auto" data-id="element-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-slate-500" data-id="element-25">
          <p data-id="element-26">© 2024 IT Support Portal. Internal use only.</p>
        </div>
      </footer>
    </div>;
}